module.exports = __webpack_public_path__ + "img/quest_visualization_stage_dots.c0f852c2.svg";